import { render, staticRenderFns } from "./CustomerDeposit.vue?vue&type=template&id=6b34b2f5"
import script from "./CustomerDeposit.vue?vue&type=script&lang=js"
export * from "./CustomerDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports